import { useMutation } from "@tanstack/react-query";

import apiClient from "@app/common/api/apiClient";
import useLocalStorage from "@app/common/hooks/useLocalStorage";
import type { PersistedLogin } from "@app/common/types";

const useDetectedLogin = () => {
  const [persistedLogin, setPersistedLogin] =
    useLocalStorage<PersistedLogin | null>("persistedLogin", null, {
      userDependent: false,
    });

  const getLoginMethods = useMutation({
    mutationFn: apiClient.auth.getLoginMethods,
  });

  return {
    persistedLogin,
    setPersistedLogin,
    getLoginMethods,
    hasPersistedLogin: persistedLogin?.method != null,
  };
};

export default useDetectedLogin;
